import { Routes, Route } from "react-router-dom"
import Home from './pages/Home'
import About from "./pages/About"
import Contact from "./pages/Contact"
import Product from "./pages/Product"
import Footer from "./pages/Footer";
import RealEstate from "./pages/RealEstate";
import NavTabs from "./DrawerAppBar"
import Navbar from "./component/Navbar"
import { Outlet } from 'react-router-dom'
import HotelBooking from "./pages/HotelBooking"

function BasicLayout() {
  return (
    <>
      <Navbar/>
      <Outlet />
      <Footer/>
    </>
  )
}

function App() {
  return (
    <div className="App">
      <Routes>
      <Route path="/" element={<BasicLayout />}>
        <Route index element={<Home />}/>
        <Route path="about" element={ <About/> } />
        <Route path="contact" element={ <Contact/> } />
        <Route path="realestate" element={ <RealEstate/> } />
        <Route path="hotelBooking" element={ <HotelBooking/> } />
        
        </Route>
       
      </Routes>
    </div>
  )
}

export default App